import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'reward-item',
  templateUrl: './reward-item.component.html',
  styleUrls: ['./reward-item.component.scss'],
})
export class RewardItemComponent {
  private _color?: string;
  private _selectedColor?: string;
  private _Tcolor?: string;
  private _selectedTColor?: string;

  @Input() buttonText?: string;

  @Input() iconSrc?: string;
  
  @Input()
  set color(value: string | undefined) {
    this._color = value;
    this._Tcolor = value;
  }

  @Input()
  set selectedColor(value: string | undefined) {
    this._selectedColor = value;
    this._selectedTColor = value;
  }
    @HostBinding('style.--button-color')
  get buttonColor(): string | null {
    return this._color ? `var(--ion-color-${this._color})` : null;
  }

  @HostBinding('style.--button-selected-color')
  get buttonSelectedColor(): string | null {
    return this._selectedColor ? `var(--ion-color-${this._selectedColor})` : null;
  }
      @HostBinding('style.--button-Tcolor')
  get buttonTColor(): string | null {
    return this._Tcolor ? `var(--ion-text-${this._color})` : null;
  }

  @HostBinding('style.--button-selected-Tcolor')
  get buttonSelectedTColor(): string | null {
    return this._selectedTColor ? `var(--ion-text-${this._selectedColor})` : null;
  }


  @Input() disabled: boolean = false;
  

  @Input() isActive: boolean = false;

  @Output() buttonClick? = new EventEmitter<void>();


  constructor() {}

  //   getGradientStyle(): { [key: string]: string } {
  //   if (this.color) {
  //           const gradient = `linear-gradient(
  //       var(--ion-shadeLight-${this.color}),
  //       var(--ion-color-${this.color}),
  //       var(--ion-shadeLight-${this.color})
  //     )`;
  //     return { 'background-image': gradient };
  //   }
  //   return {}; // Return empty object if no color is provided
  // }
  //     getSelectedStyle(): { [key: string]: string } {
  //   if (this.selectedColor) {
  //           const gradient = `linear-gradient(
  //       var(--ion-shadeLight-${this.selectedColor}),
  //       var(--ion-color-${this.selectedColor}),
  //       var(--ion-shadeLight-${this.selectedColor})
  //     )`;
  //     return { 'background-image': gradient };
  //   }
  //   return {}; // Return empty object if no color is provided
  // }
  async onButtonClick() {
    if (this.disabled==false){
    this.buttonClick.emit(); 
    }
  }

}